// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 267 ? "3ed1ab01" : chunkId) + "." + {"42":"788a91c89b063a50","267":"589a85368fa67fc5","667":"71c5484a03e8673d","812":"dfb27f63b802ffeb"}[chunkId] + ".js";
};